import { FC } from "react";
import { Route, Switch } from "react-router-dom";
import TopBanner from '../pages/homepage/top-banner';
import TopBannerCreate from '../pages/homepage/top-banner/create';
import TopBannerEdit from '../pages/homepage/top-banner/edit';
import MainBanner from '../pages/homepage/main-banner';
import MainBannerCreate from '../pages/homepage/main-banner/create';
import MainBannerEdit from '../pages/homepage/main-banner/edit';
import Notice from '../pages/homepage/notice';
import NoticeCreate from '../pages/homepage/notice/create';
import Greeting from '../pages/homepage/greeting';
import NoticeRead from "../pages/homepage/notice/read";
import NoticeEdit from "../pages/homepage/notice/edit";
import Facility from "../pages/homepage/facility";
import Education from "../pages/homepage/education";
import Tuition from "../pages/homepage/tuition";
import Transport from "../pages/homepage/transport";
import EducationCreate from "../pages/homepage/education/create";
import EducationRead from "../pages/homepage/education/read";
import EducationEdit from "../pages/homepage/education/edit";
import HomepageFaq from "../pages/homepage/faq";
import HomepageFaqCreate from "../pages/homepage/faq/create";
import HomepageFaqRead from "../pages/homepage/faq/read";
import HomepageFaqEdit from "../pages/homepage/faq/edit";
import HomepageInquiry from "../pages/homepage/inquiry";
import HomepageInquiryRead from "../pages/homepage/inquiry/read";
import HomepageArchive from "../pages/homepage/archive";
import ArchiveCreate from "../pages/homepage/archive/create";
import ArchiveRead from "../pages/homepage/archive/read";
import ArchiveEdit from "../pages/homepage/archive/edit";
import SurveyQuestion from "../pages/homepage/survey-question";
import SurveyQuestionCreate from "../pages/homepage/survey-question/create";
import SurveyQuestionRead from "../pages/homepage/survey-question/read";
import Survey from "../pages/homepage/survey";
import SurveyCreate from "../pages/homepage/survey/create";
import SurveyEdit from "../pages/homepage/survey/edit";
import HomepageMember from "../pages/homepage/member";
import Popup from "../pages/homepage/popup";
import PopupCreate from "../pages/homepage/popup/create";
import PopupRead from "../pages/homepage/popup/read";
import PopupEdit from "../pages/homepage/popup/edit";

const HomepageRouter: FC = () => {
  return (
    <Switch>
      <Route path='/homepage/top-banner' exact component={TopBanner} />
      <Route path='/homepage/top-banner/create' exact component={TopBannerCreate} />
      <Route path='/homepage/top-banner/:bannerCode' exact component={TopBannerEdit} />
      <Route path='/homepage/main-banner' exact component={MainBanner} />
      <Route path='/homepage/main-banner/create' exact component={MainBannerCreate} />
      <Route path='/homepage/main-banner/:bannerCode' exact component={MainBannerEdit} />
      <Route path='/homepage/survey-question' exact component={SurveyQuestion} />
      <Route path='/homepage/survey-question/create' exact component={SurveyQuestionCreate} />
      <Route path='/homepage/survey-question/:questionCode' exact component={SurveyQuestionRead} />
      <Route path='/homepage/survey' exact component={Survey} />
      <Route path='/homepage/survey/create' exact component={SurveyCreate} />
      <Route path='/homepage/survey/:surveyCode/edit' exact component={SurveyEdit} />
      <Route path='/homepage/notice' exact component={Notice} />
      <Route path='/homepage/notice/create' exact component={NoticeCreate} />
      <Route path='/homepage/notice/:campusCode/:noticeCode' exact component={NoticeRead} />
      <Route path='/homepage/notice/:campusCode/:noticeCode/edit' exact component={NoticeEdit} />
      <Route path='/homepage/greeting' exact component={Greeting} />
      <Route path='/homepage/facility' exact component={Facility} />
      <Route path='/homepage/education' exact component={Education} />
      <Route path='/homepage/education/create' exact component={EducationCreate} />
      <Route path='/homepage/education/:bulletinCode' exact component={EducationRead} />
      <Route path='/homepage/education/:bulletinCode/edit' exact component={EducationEdit} />
      <Route path='/homepage/faq' exact component={HomepageFaq} />
      <Route path='/homepage/faq/create' exact component={HomepageFaqCreate} />
      <Route path='/homepage/faq/:faqCode' exact component={HomepageFaqRead} />
      <Route path='/homepage/faq/:faqCode/edit' exact component={HomepageFaqEdit} />
      <Route path='/homepage/inquiry' exact component={HomepageInquiry} />
      <Route path='/homepage/inquiry/:qnaCode' exact component={HomepageInquiryRead} />
      <Route path='/homepage/tuition' exact component={Tuition} />
      <Route path='/homepage/transport' exact component={Transport} />
      <Route path='/homepage/archive' exact component={HomepageArchive} />
      <Route path='/homepage/archive/create' exact component={ArchiveCreate} />
      <Route path='/homepage/archive/:archiveCode' exact component={ArchiveRead} />
      <Route path='/homepage/archive/:archiveCode/edit' exact component={ArchiveEdit} />
      <Route path='/homepage/member' exact component={HomepageMember} />
      <Route path='/homepage/popup' exact component={Popup} />
      <Route path='/homepage/popup/create' exact component={PopupCreate} />
      <Route path='/homepage/popup/:campusCode/:popupCode' exact component={PopupRead} />
      <Route path='/homepage/popup/:campusCode/:popupCode/edit' exact component={PopupEdit} />
    </Switch>    
  );
}

export default HomepageRouter;
